"use client";

import { motion } from "framer-motion";

export const MotionDiv = motion.div;
export const MotionP = motion.p;
export const MotionSpan = motion.span;
export const MotionButton = motion.button;
export const MotionH3 = motion.h3;
export const MotionH1 = motion.h1;
export const MotionH2 = motion.h2;
export const MotionSmall = motion.small;
export const MotionImage = motion.img;